import React from "react";
import { MessageSquarePlus } from "lucide-react";
import KyvaIcon from "../../icons/kyva";

interface AskKyvaButtonProps {
    position: { x: number; y: number } | null;
    onClick: () => void;
}

const AskKyvaButton: React.FC<AskKyvaButtonProps> = ({ position, onClick }) => {
    if (!position) return null;

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
            className="fixed z-50 flex items-center gap-2 px-3 py-1.5 bg-surface-overlay border border-violet-200 dark:border-violet-500/40 text-violet-700 dark:text-violet-300 rounded-full shadow-lg ring-1 ring-black/5 dark:ring-gray-700 hover:bg-violet-50 dark:hover:bg-violet-500/10 transition-all duration-200 transform -translate-x-1/2 -translate-y-full mb-2 animate-in fade-in zoom-in duration-200"
            style={{
                left: position.x,
                top: position.y - 10, // Position slightly above selection
            }}
        >
            <div className="w-4 h-4">
                <KyvaIcon width="16" height="16" />
            </div>
            <span className="text-sm font-medium">Ask Kyva</span>
        </button>
    );
};

export default AskKyvaButton;
